import { Card, Grid, Image, Flex, styled } from '@grupoboticario/flora-react';

export const styles = {
  Image: styled(Image, {
    overflow: 'hidden',
    borderRadius: '$small',
  }),

  RewardCard: styled(Card, {
    backgroundColor: '$backgroundSecondary',
    padding: '$4',
    width: '100%',

    '&::before': {
      boxShadow: 'initial',
    },
  }),

  RewardInfo: styled(Flex, {
    flexDirection: 'column',
    gap: '$2',
    width: '100%',
  }),

  RewardWrapper: styled(Grid, {
    gap: '$4',
    width: '100%',

    '@tablet': {
      gap: '$9',
      gridTemplateColumns: 'repeat(auto-fill, minmax(calc($22 * 3), 1fr))',
    },

    '@desktop': {
      gap: '$9',
      gridTemplateColumns: 'repeat(auto-fill, minmax(calc($22 * 4), 1fr))',
    },
  }),

  Wrapper: styled(Flex, {
    gap: '$4',
    flexDirection: 'column',
    width: '100%',
  }),
};

export default styles;
